import { render, staticRenderFns } from "./home.vue?vue&type=template&id=1a23562d&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=1a23562d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a23562d",
  null
  
)

export default component.exports